import { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import Page from "../../../components/Page";
import styles from "./style.module.css";
import PostJob from "../../../EmployerPages/Dashboard/PostUpdate";
import { backendUrl } from "../../../constants";
import JobCard from "../../../pages/Search/JobCard";
import { showNotification } from "@mantine/notifications";

const Index = ({ t }) => {
  let userData = JSON.parse(localStorage.getItem("userData"));
  const [update, setUpdate] = useState({ userId: userData.id, status: "" });
  const [jobs, setJobs] = useState([]);

  //jobs
  useEffect(() => {
    setJobs([]);
    let options = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "content-type": "application/json",
      },
      body: JSON.stringify({}),
    };
    fetch(`${backendUrl}user/searchJobs`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = {
            key: obj?._id,
            appliedCandidates: obj?.appliedCandidates,
            title: obj?.jobTitle,
            logo: obj?.attachedFiles[0]?.filePath,
            company: obj?.createdBy?.companyName,
            description: obj?.jobDescription,
            location: obj?.empLocation?.city,
            date: obj?.createdDate,
            remote: obj?.remotely,
          };
          setJobs((jobs) => [...jobs, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //post news update
  const handleUpdate = () => {
    const options = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "content-type": "application/json",
      },
      body: JSON.stringify(update),
    };
    fetch(`${backendUrl}user/postStatusUpdate`, options)
      .then((response) => {
        setUpdate({ userId: userData.id, status: "" });
        showNotification({
          message: "Posted new update!",
          color: "green",
        });
      })
      .catch((err) => console.error(err));
  };

  return (
    <Page
      style={{ backgroundColor: "rgb(248, 248, 248)", padding: "20px 0px" }}
    >
      <div className={styles.home}>
        <h4 className="text-dark mb-2">Welcome back {userData.firstName}!</h4>
        <PostJob
          handleUpdate={handleUpdate}
          setUpdate={setUpdate}
          update={update}
        />
        <h6 className="text-dark mb-2 text-center">Recommended Jobs for you</h6>
        <div>
          {jobs.length < 1 ? (
            <h2 className="text-dark text-center">No Jobs Found.</h2>
          ) : (
            jobs?.map((obj, key) => <JobCard data={obj} key={key} />)
          )}
        </div>
      </div>
    </Page>
  );
};

export default withTranslation()(Index);
